import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Activity } from 'services';
import { curriculum_manager } from 'utils/constants';
import { Results } from './components';
const ActivityList = props => {
  const { student_id, teacher_id, module_id, lesson_id, slot_id } = props;

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Activities" subheader="Activities Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Activity.list}
      title="Activities"
      name="activities"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      filters={{
        limit: 10,
        offset: 0,
        count: 0,
        search: "",
        student: student_id,
        teacher: teacher_id,
        lesson: lesson_id,
        module: module_id,
        slot: slot_id
      }}
    />
  );
};

export default ActivityList;
